/**
 * Statistics 도메인 Zod 스키마
 */
import { z } from 'zod';
// ============================================================
// 입력 스키마 (Input Schemas)
// ============================================================
/**
 * 우수 학생 조회 입력 스키마
 */
export const getExcellentStudentsInputSchema = z.object({
    year: z.number().int().positive().optional(),
});
/**
 * 통계 공통 입력 스키마
 */
export const statisticsInputSchema = z.object({
    year: z.number().int().positive().optional(),
    month: z.number().int().min(1).max(12).optional(),
    week: z.number().int().min(1).max(5).optional(),
});
/**
 * TOP 조회용 입력 스키마
 */
export const topStatisticsInputSchema = z.object({
    year: z.number().int().positive().optional(),
    month: z.number().int().min(1).max(12).optional(),
    week: z.number().int().min(1).max(5).optional(),
    limit: z.number().int().positive().max(10).optional().default(5),
});
